import React from "react";

const FormValidation = (props) => {
  // Normalize various error payload shapes into a simple string array
  const normalizedErrors = (() => {
    const rawErrors = props && props.error ? props.error : {};

    // If the API returned a plain string
    if (typeof rawErrors === "string") {
      return [rawErrors];
    }

    // If the API returned an array of strings
    if (Array.isArray(rawErrors)) {
      return rawErrors.map((e) => (typeof e === "string" ? e : String(e)));
    }

    // Fallback: assume an object of arrays/strings like { field: ["msg"] }
    const messages = [];
    Object.keys(rawErrors || {}).forEach((key) => {
      const value = rawErrors[key];
      if (Array.isArray(value)) {
        if (value.length > 0) messages.push(String(value[0]));
      } else if (typeof value === "string") {
        messages.push(value);
      } else if (value) {
        messages.push(String(value));
      }
    });
    return messages;
  })();

  if (normalizedErrors.length > 0) {
    window.scrollTo(0, 0);
  }

  return (
    normalizedErrors.length > 0 && (
      <>
        <ul className="parsley-errors-list filled" style={{ marginBottom: "20px" }}>
          {normalizedErrors.map((item, index) => (
            <li key={index} className="parsley-required" style={{ color: "red" }}>
              <span className="help-block">{item}</span>
            </li>
          ))}
        </ul>
      </>
    )
  );
};

export default FormValidation;
